import styled from 'styled-components';

export type ErrorStyleProps = Record<string, string>;

// TODO: should be adopted by other components
export const ErrorMessageStyles = styled.p<ErrorStyleProps>`
  position: ${(props) => (props.position ? props.position : 'static')};
  bottom: ${(props) => (props.bottom ? props.bottom : '-17px')};
  color: ${(props) => (props.color ? props.color : '#cf4845')};
  padding: ${(props) => (props.position !== 'absolute' ? '5px 0 0 0' : '0')};
  margin: 0;
  left: 0;
  font-size: 12px;
  white-space: nowrap;
`;
